import { render } from "./Wedge.vue?vue&type=template&id=9436d7da"
import script from "./Wedge.vue?vue&type=script&lang=js"
export * from "./Wedge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__